import { render, staticRenderFns } from "./PaymentTariffTypeList.vue?vue&type=template&id=b7748554&lang=pug"
import script from "./PaymentTariffTypeList.vue?vue&type=script&lang=js"
export * from "./PaymentTariffTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports